import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from "@angular/router";
import * as _ from "lodash";
import { AuthService } from "../model/auth-model/auth.service";
import SystemConstants from "../util/constants/SystemConstants";

@Injectable({
  providedIn: "root",
})
export class AuthGuard implements CanActivate {
  constructor(private routes: Router, private authService: AuthService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const currentUserRole = this.authService.getUserData() && this.authService.getUserData().data && this.authService.getUserData().data.role
    if (this.authService.isAuthenticated() && (Number(currentUserRole) === 0 || currentUserRole)) {
      const isAuthorizedUser =  _.isArray(next.data.role) ? next.data && next.data.role &&  next.data.role.includes(currentUserRole)
        : currentUserRole === Number(next.data && next.data.role)
      if (!isAuthorizedUser) {
        this.routes.navigate(['/']);
        return false;
      }
      return true;
    }
    this.authService.logout();
    return false;
  }
}
